import React from 'react';
import { Icon } from 'react-fa';
import './Reportes.css';
import PantallaReporte from './PantallaReporte';

const GrupoReportes = ({ grupo, setReporteSeleccionado, producto}) => {

	return(
	<div>
		<h2>{grupo.key}</h2>		
		
        <ListadoReportes reportesParam={grupo.data} setReporteSeleccionado={setReporteSeleccionado} producto={producto} />	
            
	</div>
	);	
}

const FilaReportes = ({ reportes, setReporteSeleccionado }) =>
{
    return (
    <div className="ReporteFila">
      {reportes.map(r => <ElementoReporte reporte={r} setReporteSeleccionado={setReporteSeleccionado} />)}
    </div>
    );

}

const ListadoReportes = ({ reportesParam, setReporteSeleccionado, producto }) =>
{

    const maxReportesFila = 4;
    const cantFilas = Math.ceil(reportesParam.length / maxReportesFila);
    const filas = [];
    var i = 0;

    for (i=0; i < cantFilas ; i++)
    {
        const inicioFila = (i * maxReportesFila);
        const finFila = (i * maxReportesFila) + maxReportesFila;
        const fila = reportesParam.slice(inicioFila, finFila);
        
        filas.push(fila);
    }

    return (
    <div className={"ListaReportes " + producto}>     
      {filas.map(fila => <FilaReportes reportes={fila} setReporteSeleccionado={setReporteSeleccionado} /> )}
    </div>
    );
    
}

const ElementoReporte = ({reporte, setReporteSeleccionado}) =>
{
    return (
    <div className="ReporteElement clickable" onClick={() => setReporteSeleccionado(reporte)}>
        <div className="LineaSuperior"></div>
        <p className="TextoDiv">{reporte.description}</p>        
        <span className="FlechaDiv">
          <Icon className="FlechaDropdown" name="chevron-down" size="lg" />
        </span>
    </div>
    );
}

export default GrupoReportes;


// WEBPACK FOOTER //
// ./Portico/App/Screens/InvocadorReportes/components/GrupoReportes.jsx